export default __webpack_public_path__ + "static/media/epic.55add676.jpg";